import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.is-extensible";
import CoreView from "react-native-web/dist/exports/View";
import CoreText from "react-native-web/dist/exports/Text";
import CoreImage from "react-native-web/dist/exports/Image";
import createComponent from "./createAnimatableComponent";
import { initializeRegistryWithDefinitions } from "./registry";
import * as ANIMATION_DEFINITIONS from "./definitions";
initializeRegistryWithDefinitions(ANIMATION_DEFINITIONS);
export var createAnimatableComponent = createComponent;

if (typeof createAnimatableComponent !== 'undefined' && createAnimatableComponent && createAnimatableComponent === Object(createAnimatableComponent) && Object.isExtensible(createAnimatableComponent) && !createAnimatableComponent.hasOwnProperty('__filemeta')) {
  Object.defineProperty(createAnimatableComponent, '__filemeta', {
    configurable: true,
    value: {
      name: "createAnimatableComponent",
      filename: "node_modules/react-native-animatable/index.js"
    }
  });
}

export var View = createComponent(CoreView);

if (typeof View !== 'undefined' && View && View === Object(View) && Object.isExtensible(View) && !View.hasOwnProperty('__filemeta')) {
  Object.defineProperty(View, '__filemeta', {
    configurable: true,
    value: {
      name: "View",
      filename: "node_modules/react-native-animatable/index.js"
    }
  });
}

export var Text = createComponent(CoreText);

if (typeof Text !== 'undefined' && Text && Text === Object(Text) && Object.isExtensible(Text) && !Text.hasOwnProperty('__filemeta')) {
  Object.defineProperty(Text, '__filemeta', {
    configurable: true,
    value: {
      name: "Text",
      filename: "node_modules/react-native-animatable/index.js"
    }
  });
}

export var Image = createComponent(CoreImage);

if (typeof Image !== 'undefined' && Image && Image === Object(Image) && Object.isExtensible(Image) && !Image.hasOwnProperty('__filemeta')) {
  Object.defineProperty(Image, '__filemeta', {
    configurable: true,
    value: {
      name: "Image",
      filename: "node_modules/react-native-animatable/index.js"
    }
  });
}

export { default as createAnimation } from "./createAnimation";

if (typeof createAnimation !== 'undefined' && createAnimation && createAnimation === Object(createAnimation) && Object.isExtensible(createAnimation) && !createAnimation.hasOwnProperty('__filemeta')) {
  Object.defineProperty(createAnimation, '__filemeta', {
    configurable: true,
    value: {
      name: "createAnimation",
      filename: "node_modules/react-native-animatable/index.js"
    }
  });
}

export { registerAnimation, initializeRegistryWithDefinitions } from "./registry";

if (typeof initializeRegistryWithDefinitions !== 'undefined' && initializeRegistryWithDefinitions && initializeRegistryWithDefinitions === Object(initializeRegistryWithDefinitions) && Object.isExtensible(initializeRegistryWithDefinitions) && !initializeRegistryWithDefinitions.hasOwnProperty('__filemeta')) {
  Object.defineProperty(initializeRegistryWithDefinitions, '__filemeta', {
    configurable: true,
    value: {
      name: "initializeRegistryWithDefinitions",
      filename: "node_modules/react-native-animatable/index.js"
    }
  });
}

if (typeof registerAnimation !== 'undefined' && registerAnimation && registerAnimation === Object(registerAnimation) && Object.isExtensible(registerAnimation) && !registerAnimation.hasOwnProperty('__filemeta')) {
  Object.defineProperty(registerAnimation, '__filemeta', {
    configurable: true,
    value: {
      name: "registerAnimation",
      filename: "node_modules/react-native-animatable/index.js"
    }
  });
}